export default __webpack_public_path__ + "static/samsunspor-logo-6ec0a2f5305aeafef2109a628e293bcb.png";